var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      style: _vm.removeWhenPivotCompletelyInVue,
      attrs: { role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable",
          style: _vm.removeWhenPivotCompletelyInVue2,
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.$t("pivotTemplates")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "btn-group mb-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn c-pointer",
                    class: {
                      "btn-primary": _vm.selectedTab === "own",
                      "btn-default": _vm.selectedTab !== "own"
                    },
                    on: {
                      click: function($event) {
                        _vm.selectedTab = "own"
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("pivotTemplateOwn")) +
                        "\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn c-pointer",
                    class: {
                      "btn-primary": _vm.selectedTab === "shared",
                      "btn-default": _vm.selectedTab !== "shared"
                    },
                    on: {
                      click: function($event) {
                        _vm.selectedTab = "shared"
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("pivotTemplateShared")) +
                        "\n                    "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedTab === "own",
                      expression: "selectedTab === 'own'"
                    }
                  ]
                },
                [
                  _vm.hasTemplates
                    ? [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("pivotTemplateOwnPrivate")) +
                            "\n                        "
                        ),
                        _c(
                          "ul",
                          { staticClass: "list-group" },
                          _vm._l(_vm.templates.templates, function(template) {
                            return _c(
                              "li",
                              {
                                key: template,
                                staticClass: "list-group-item c-pointer",
                                on: {
                                  click: function($event) {
                                    _vm.$emit("selected", template)
                                    _vm.closeModal()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(template.name) +
                                    "\n                                "
                                ),
                                _c("div", { staticClass: "float-right" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm btn-danger",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.$emit("deleted", template)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-dumpster"
                                      })
                                    ]
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasTemplatesSharedOwn
                    ? [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("pivotTemplateOwnShared")) +
                            "\n                        "
                        ),
                        _c(
                          "ul",
                          { staticClass: "list-group" },
                          _vm._l(_vm.templatesSharedOwn.templates, function(
                            template
                          ) {
                            return _c(
                              "li",
                              {
                                key: template,
                                staticClass: "list-group-item c-pointer",
                                on: {
                                  click: function($event) {
                                    _vm.$emit("selected", template)
                                    _vm.closeModal()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(template.name) +
                                    "\n                                "
                                ),
                                _c("div", { staticClass: "float-right" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm btn-danger",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.$emit("deleted", template)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-dumpster"
                                      })
                                    ]
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hasTemplates && !_vm.hasTemplatesSharedOwn
                    ? _c("div", [_vm._v(_vm._s(_vm.$t("pivotNoTemplates")))])
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedTab === "shared",
                      expression: "selectedTab === 'shared'"
                    }
                  ]
                },
                [
                  _vm.hasTemplatesSharedOther
                    ? _c(
                        "ul",
                        { staticClass: "list-group" },
                        _vm._l(_vm.templatesSharedOther.templates, function(
                          template
                        ) {
                          return _c(
                            "li",
                            {
                              key: template,
                              staticClass: "list-group-item c-pointer",
                              on: {
                                click: function($event) {
                                  _vm.$emit("selected", template)
                                  _vm.closeModal()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(template.name) +
                                  "\n                        "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _c("div", [_vm._v(_vm._s(_vm.$t("pivotNoTemplates")))])
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }